import { useToast } from "@aircall/tractor";
import { useCopyToClipboard } from "@dashboard/library";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useTrack } from "@/hooks/useTrack/useTrack";

export function useShareLink() {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { track } = useTrack();

  const copy = useCopyToClipboard();

  return useCallback(() => {
    copy(window.location.href);
    track("sharing_link_selected");

    showToast({
      variant: "success",
      dismissIn: 3000,
      message: t("toast.copied"),
    });
  }, [copy, showToast, t, track]);
}
